import React, {useEffect, useRef, useState} from 'react';
import {Button, Checkbox, Col, Drawer, notification, PageHeader, Row, Upload} from 'antd';
import {ReloadOutlined, UploadOutlined,} from '@ant-design/icons';
import {useUserPermissions} from '../../auth/userHooks';
import {getD365Uploads, uploadD365AdjustmentsFile} from '../../api/d365Api';
import _ from 'lodash';
import {UploadsTable} from "./UploadsTable";
import {PREFERRED_DATETIME_FORMAT} from "../../util/time";
import moment from "moment";
import {Adjustments} from "./Adjustments";
import {getPaginationConfig} from "../../util/showAllPagination";
import {useDynamicTableHeight} from "../../util/useDynamicTableHeight";


const Uploads = () => {
  const [uploads, setUploads] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [uploading, setUploading] = useState(false);
  const permissions = useUserPermissions();
  const [selectedUpload, setSelectedUpload] = useState(null);
  const [showAdjustments, setShowAdjustments] = useState(null);
  const [disableUploads, setDisableUploads] = useState(false);
  const [hideColumns, setHideColumns] = useState(true);
  const tableContainerRef = useRef(null);
  const tableHeight = useDynamicTableHeight(tableContainerRef);


  const uploadAdjustmentsFile = file => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      if (reader.result) {
        setUploading(true);
        const data = _.replace(reader.result, 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,', '');
        // @todo improve error handling, it is not checking for 404 and bad response
        uploadD365AdjustmentsFile(data, file.name).then(() => {
          notification.success({
            message: 'Success',
            description: `file uploaded and upload process event created!`,
            placement: 'bottomRight',
          });
        }).finally(() => {
          setUploading(false);
          loadUploads();
        })
      }
    };
  }

  const uploadProps = {
    beforeUpload: file => {
      setFileList([]);
      if (file && file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        uploadAdjustmentsFile(file);
      } else {
        notification.error({
          message: 'Error',
          description: 'Adjustment Upload file must be an XLSX format',
          placement: 'bottomRight'
        });
      }
      return false;
    },
    fileList,
    maxCount: 1,

  }
  const loadUploads = async () => {
    try {
      setLoading(true);
      const uploads = await getD365Uploads();
      let hasPending = 0;
      _.each(uploads, u => {
        if (["PENDING", "STARTED"].includes(u.status)) {
          hasPending++;
        }
      });
      setUploads(uploads);
      setDisableUploads(hasPending > 0);
    } catch (e) {
      console.error(`Could not get D365 uploads`);
    } finally {
      setLoading(false);
    }
  };

  const notificationError = (msg) => {
    console.error(msg)
    notification.error({
      message: 'Error',
      description: msg,
      placement: 'bottomRight',
      duration: 10,
    });
  }

  const hideAdjustmentsView = () => {
    setSelectedUpload(null);
    setShowAdjustments(false);
  };

  const handleCheckbox = (t) => {
    setHideColumns(!t.target.checked)
  }

  useEffect(() => {
    loadUploads();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Row>
        <Col span={16} style={{marginRight: 10}}>
          <PageHeader
            title="D365 Adjustments Uploads"
            subTitle={`(${uploads.length} shown)`}
            style={{padding: 0}}
          />
        </Col>
        <Col flex="auto"></Col>
        {permissions !== null && permissions.canManageD365 && (
          <>
            <Col>
              <Checkbox
                onChange={handleCheckbox}
                disabled={loading}
                style={{float: 'right', marginRight: 10}}
              >
                Show Auditing
              </Checkbox>
            </Col>
            <Col style={{marginRight: 10}}>
              <Upload {...uploadProps} >
                <Button loading={uploading} icon={<UploadOutlined/>}>
                  Upload Adjustments XLSX
                </Button>
              </Upload>
            </Col>
          </>
        )}
        <Col>
          <Button
            style={{float: 'right'}}
            onClick={() => loadUploads()}
            loading={loading}
            icon={<ReloadOutlined/>}
          >
            Refresh
          </Button>

        </Col>
      </Row>


      <UploadsTable
        uploads={uploads}
        pagination={getPaginationConfig(uploads.length)}
        scroll={{x: 1500, y: tableHeight}}
        permissions={permissions}
        loading={loading}
        setLoading={setLoading}
        hideColumns={hideColumns}
        notificationError={notificationError}
        loadUploads={loadUploads}
        disableUploads={disableUploads}
        setSelectedUpload={setSelectedUpload}
        setShowAdjustments={setShowAdjustments}
      />

        <Drawer
            title={"Adjustments for upload #" + selectedUpload?.ID +
                " created by " + selectedUpload?.createdBy +
                " on " + (selectedUpload ? moment(selectedUpload.CreatedAt).format(PREFERRED_DATETIME_FORMAT) : "") +
                ", last updated by " + selectedUpload?.updatedBy + " on " +
              (selectedUpload ? moment(selectedUpload.UpdatedAt).format(PREFERRED_DATETIME_FORMAT) : "")}
            placement="bottom"
            closable={true}
            onClose={hideAdjustmentsView}
            open={showAdjustments}
            height="100%"
        >
          {selectedUpload && (
              <Adjustments upload={selectedUpload}/>
          )}
        </Drawer>
      </>
  )

};

export {Uploads};
